<template>
  <div class="employeeLIstVue">
    <!-- Main Body Content area -->
    <div class="o-main-content-area o-main-content-area--padBotoomNone">
        <!-- Heading Section -->
        <div class="row c-responsive-fixwidth">
            <div class="col-md-12">
                <h1 class="h1 text-center mt-30 mb-20">Employer Merger Form</h1>
            </div>
        </div>
        <!-- /Heading Section -->
    </div>

    <div class="o-ndividualArea c-responsive-fixwidth">
      <div class="col-md-6 col-md-offset-3">
          <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white fix-height" v-loading="employersLoading || loading">
              <div class="row">
                  
                  <div class="col-sm-12">
                    <div class="form-group ">
                      <label class="common-label-text o-super-label">Select Source Employers:</label>
                      <el-select
                        v-model="mergerForm.sourceEmployers"
                        filterable
                        :collapse-tags="mergerForm.sourceEmployers.length>=2"
                        value-key="id"
                        multiple
                        style="width: 100%;"
                        placeholder="Please Enter Source Employer Name">
                        <el-option
                          v-for="emp in employersList"
                          :key="emp.id"
                          :label="displayLabel(emp)"
                          :value="emp.id"
                          :disabled="disableSourceOption(emp.id)">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-sm-12">
                      <div class="form-group ">
                          <label class="common-label-text o-super-label">Select Target Employer:</label>              
                          <el-select
                            v-model="mergerForm.targetEmployer"
                            filterable
                            style="width: 100%;"
                            placeholder="Please Enter Target Employer Name">
                            <el-option
                              v-for="emp in employersList"
                              :key="emp.id"
                              :label="displayLabel(emp)"
                              :value="emp.id"
                              :disabled="disableTargetOption(emp.id)">
                            </el-option>
                          </el-select>
                            
                      </div>
                  </div>
              </div>

              <a href="javascript: void(0)" @click="mergeEmployers()" class="c-solid-btn c-solid-btn--green">Merge Employers</a>

              <div class="mt-20">
                <sup class="note-label">
                  Note: 
                </sup>
                <ul>
                  <li class="mt-5 lh-2">
                    This Admin tool is to combine the users of employes to the target without breaking Employer/Job associations across clients.
                  </li>
                </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex';    
    import service from '../../../services.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
            }),    
        },
        data() {
          return { 
            employersLoading: false,
            employersList: [],
            source_employers: [],
            target_employer: '',
            savedEmployees: [], 
            employeesList: [],
            mergerForm: {
              sourceEmployers: [],
              targetEmployer: ""
            },
            loading: false
          };
        },
        beforeMount() {},
        methods: {
          async getAllEmployers(){
              this.employersList=[];
              this.savedEmployees =[];
              this.loading=true;
              await service.get('employer', {
                  'Authorization': this.userToken,
                  'sort': 'fname_asc',
                  'search': '',
                  'pagination': 0
              }).then((res) => {
                  this.loading=false;
                  this.employersList = res.data.result;
              }).catch((err) => {
                  this.loading=false;
                  console.log('error',err);
                  this.$message({
                      type: 'error',
                      message: 'Sorry, Something Went Wrong: Please try again later.'
                  });
              });   
          },
          displayLabel(emp) {
            let name = emp.name;
            if(emp.employer_users&&emp.employer_users.length&&emp.employer_users[0].user&& emp.employer_users[0].user.first_name) {
              name = emp.name + ' - ' + emp.employer_users[0].user.first_name;
            }
            return name;
          },

          disableSourceOption(id) {
            let status = false;
            if(this.mergerForm.targetEmployer!=''&&this.mergerForm.targetEmployer==id) status = true;
            return status;
          },

          disableTargetOption(id) {
            let status = false;
            if(this.mergerForm.sourceEmployers!=[]) {
              for(let i=0; i<this.mergerForm.sourceEmployers.length; i++){
                if(this.mergerForm.sourceEmployers[i].id == id) {
                  status = true;
                  break;
                }
              }
            }
            return status;
          },

          async mergeEmployers() {
            this.employersLoading = true;
            await service.post('superadmin/mergeEmployer', {
                'secondary_ids': this.mergerForm.sourceEmployers,
                'primary_id': this.mergerForm.targetEmployer
            }, {
                'Authorization': this.userToken,
            }).then(async(res) => {
                this.employersLoading = false;
                this.$notify({
                    title: this.$t('success'),
                    message: res.data.status_message,
                    type: 'success'
                });                    
                this.mergerForm.sourceEmployers = [];
                this.mergerForm.targetEmployer = "";
                await this.getAllEmployers();                    
            }).catch((err) => {
                console.log(err);
                this.$message({
                    type: 'error',
                    message: 'Sorry, Something Went Wrong: Please try again later.'
                });
                this.employersLoading = false;      
            });  
          }, 
        }, 
        
        async created() {
          await this.getAllEmployers();
        }

    }

</script>
<style scoped>
.note-label {
  font-weight: 600;
  color: red;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-30 {
  margin-top: 30px;
}
.mt-5 {
  margin-top: 5px;
}
.fix-height{
  min-height: 50px;
}
.lh-2 {
  line-height: 1.5;
}
</style>




// WEBPACK FOOTER //
// src/components/superAdmin/mergers/employerMergerForm.vue